import React from "react"
import { Link } from "gatsby"
import { LOGO_PLACEMENT } from "./brand-logo-scales"
import BrandLogoImg from "./brand-logo-img"

const CARD_IMAGE_STYLE = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
}

const CaseStudyCardLink = ({ to, href, className, children }) => {
  if (href) {
    return (
      <a
        href={href}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    )
  }

  return (
    <Link to={to} className={className}>
      {children}
    </Link>
  )
}

const CaseStudyCard = ({
  caseStudy,
  wide = false,
  logoContext = LOGO_PLACEMENT.homepageCaseStudyCards,
}) => {
  const preventHyphenBreaksHtml = text =>
    text.replace(/([A-Za-z0-9])-([A-Za-z0-9])/g, "$1&#8209;$2")

  const preventHyphenBreaksText = text =>
    text.replace(/([A-Za-z0-9])-([A-Za-z0-9])/g, "$1\u2011$2")

  const sanitizeTitle = title => {
    if (!title) return ""
    // Remove all tags HTML except <strong> and </strong>
    const cleaned = title.replace(/<(?!\/?strong\b)[^>]*>/gi, "")
    return preventHyphenBreaksHtml(cleaned)
  }

  const getTitle = () => {
    if (caseStudy.custom_post_title) {
      return sanitizeTitle(caseStudy.custom_post_title)
    }
    return caseStudy.slug
      .split("-")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
  }

  const caseStudyLink = `/case-studies/${caseStudy.slug}`
  const hasExternalUrl = Boolean(caseStudy.external_url)
  const brandLogo1 = caseStudy.brand_logo_1
  const brandLogo2 = caseStudy.brand_logo_2
  const brandLogo3 = caseStudy.brand_logo_3
  const logos = [brandLogo1, brandLogo2, brandLogo3].filter(Boolean)
  const hasBrandPair = logos.length >= 2
  const cardClassName = `case-study-card ${wide ? "case-study-card--wide" : ""}`

  return (
    <CaseStudyCardLink
      className={cardClassName}
      href={hasExternalUrl ? caseStudy.external_url : undefined}
      to={caseStudyLink}
    >
      <div className="case-study-card--title">
        <h2
          className="
 
            
            has-text-purple
          "
          dangerouslySetInnerHTML={{ __html: getTitle() }}
        />
        <div className="case-study-card--brand-slot">
          {hasBrandPair && (
            <div className="case-study-card--brand-logos">
              {logos.map((src, i) => (
                <React.Fragment key={i}>
                  {i > 0 && (
                    <span className="case-study-card--brand-plus">+</span>
                  )}
                  <BrandLogoImg src={src} alt="" context={logoContext} />
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
        {caseStudy.custom_post_title && (
          <p className="has-text-purple is-size-5 is-size-6-mobile">
            {preventHyphenBreaksText(
              caseStudy.custom_post_title.replace(/<[^>]*>/g, "")
            )}
          </p>
        )}
      </div>
      <div className="case-study-card--image">
        {caseStudy.hero?.localFile?.childImageSharp?.fluid?.src && (
          <div className="case-study-card--hero">
            <img
              src={caseStudy.hero.localFile.childImageSharp.fluid.src}
              alt={
                caseStudy.custom_post_title
                  ? caseStudy.custom_post_title.replace(/<[^>]*>/g, "")
                  : "Case Study"
              }
              width={524}
              height={337}
              decoding="async"
              style={CARD_IMAGE_STYLE}
            />
          </div>
        )}
      </div>

      <div className="case-study-card--results">
        <div>
          <p className="is-size-7 has-text-purple">{caseStudy.label_2}</p>
          <p className="is-size-4 is-size-5-mobile has-text-weight-bold has-text-purple">
            {caseStudy.text_2}
          </p>
          <p className="is-size-7 has-text-purple">
            {caseStudy.label_2_bottom}
          </p>
        </div>

        <div>
          <p className="is-size-7 has-text-purple">{caseStudy.label_3}</p>
          <p className="is-size-4 has-text-weight-bold has-text-purple">
            {caseStudy.text_3}
          </p>
          <p className="is-size-7 has-text-purple">
            {caseStudy.label_3_bottom}
          </p>
        </div>
      </div>

      <div className="case-study-card--link button is-rounded is-link">
        View case study
      </div>
    </CaseStudyCardLink>
  )
}

export default React.memo(CaseStudyCard)
